import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  message: null,
  statusTable: [],
  isSyncCompleted: false
};

export const syncStatus = createAsyncThunk(
  "syncStatus",
  async (jobId) => {
    try {
      const response = await fetch(`/api/syncStatus/${jobId}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to start category sync");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const statusSlice = createSlice({
  name: "syncStatus",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(syncStatus.pending, (state) => {
        state.status = "Loading";
        state.message = null;
      })
      .addCase(syncStatus.fulfilled, (state, action) => {
        if (action.payload.data.data.result.length > 0) {
          state.status = "success";
          state.statusTable = action.payload.data.data.result;
          state.isSyncCompleted = action.payload.data.data.isSyncCompleted;
        }
      })
      .addCase(syncStatus.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default statusSlice.reducer;
